export class LocationModel {
  locationType: any;
  locationId: number;
  countryId: number;
  locationTypeId: number;
  locationSourceId: number;
  municipalityId: number;
  locationCode: string;
  locationNo: number;
  postCode: string;
  name: string;
  country: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/location-model.ts